/* tslint:disable */
/* eslint-disable */
/**
 * Airline API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime.js';
import { CfarOfferItineraryFromJSON, CfarOfferItineraryToJSON, } from './CfarOfferItinerary.js';
import { RequestTypeFromJSON, RequestTypeToJSON, } from './RequestType.js';
import { UiVariantFromJSON, UiVariantToJSON, } from './UiVariant.js';
/**
 * Check if a given object implements the CreateCfarOfferCustomerRequest interface.
 */
export function instanceOfCreateCfarOfferCustomerRequest(value) {
    let isInstance = true;
    isInstance = isInstance && "itinerary" in value;
    isInstance = isInstance && "requestType" in value;
    return isInstance;
}
export function CreateCfarOfferCustomerRequestFromJSON(json) {
    return CreateCfarOfferCustomerRequestFromJSONTyped(json, false);
}
export function CreateCfarOfferCustomerRequestFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'itinerary': (json['itinerary'].map(CfarOfferItineraryFromJSON)),
        'requestType': RequestTypeFromJSON(json['request_type']),
        'bookingDateTime': !exists(json, 'booking_date_time') ? undefined : (new Date(json['booking_date_time'])),
        'uiVariant': !exists(json, 'ui_variant') ? undefined : UiVariantFromJSON(json['ui_variant']),
    };
}
export function CreateCfarOfferCustomerRequestToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'itinerary': (value.itinerary.map(CfarOfferItineraryToJSON)),
        'request_type': RequestTypeToJSON(value.requestType),
        'booking_date_time': value.bookingDateTime === undefined ? undefined : (value.bookingDateTime.toISOString()),
        'ui_variant': UiVariantToJSON(value.uiVariant),
    };
}
